import { lazy } from "react";

import AuthGuard from "utils/route-guard/AuthGuard";
import Loadable from "ui-component/Loadable";

const ExpenseDetailAccounting = Loadable(
  lazy(() => import("views/pages/formDetails/ExpsenseDetailAccounting"))
);

const AccountingRoutes = {
  path: "/expense-detail/accounting",
  element: (
    <AuthGuard>
      <ExpenseDetailAccounting />
    </AuthGuard>
  ),
};

export default AccountingRoutes;
